"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
var DataStream_1 = __importDefault(require("./DataStream"));
/**
 * @internal
 */
function parse(array) {
  var ds = new DataStream_1.default(array, 0, DataStream_1.default.LITTLE_ENDIAN);
  var ret = [];
  while (!ds.isEof()) {
    var key = ds.readUint32();
    var low = ds.readUint16();
    var hi = ds.readUint16();
    ret.push({
      key: key,
      isStringProperty: (low & 1) != 0,
      guidIndex: (low >> 1) & 32767,
      propertyIndex: hi,
    });
  }
  return ret;
}
exports.parse = parse;